var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHashTagShare = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 100,
  height: 100,
  viewBox: "0 0 100 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.3004 9.90016L83.6204 26.4802C88.3804 27.3202 91.5004 31.9202 90.5004 36.6602L81.1004 75.3002C80.3804 78.7002 75.8604 82.9202 72.4404 83.5402L59.7204 86.7402L52.1404 96.7802C51.3004 97.8802 49.6404 97.8802 48.8204 96.7802L44.1804 90.6402L29.1204 94.4202C24.2604 95.3202 19.6604 91.9002 19.1004 87.0002L5.56044 22.2602C4.90044 16.6002 10.6804 8.92016 16.3004 9.90016Z",
  fill: "#EB8106"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4201 8.78001L86.5201 22.38C91.2801 23.22 94.4001 27.82 93.4001 32.56L82.1601 72.8C81.4401 76.2 78.7601 78.82 75.3401 79.44L62.6201 82.64L55.0401 92.68C54.2001 93.78 52.5401 93.78 51.7201 92.68L47.0801 86.54L32.0001 90.32C27.1401 91.22 22.5401 87.8 21.9801 82.9L8.46013 18.16C7.80013 12.5 12.8001 7.78001 18.4201 8.78001Z",
  fill: "url(#paint0_linear_20895_19964)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M35.3513 67.6194L39.4473 56.4356L32.7957 55.0744L33.521 51.5101L40.68 52.9751L43.9428 44.1548L36.5583 42.6436L37.2721 39.1359L45.2203 40.7625L49.2818 29.7483L52.5513 30.4174L48.4897 41.4315L57.6781 43.3118L61.7396 32.2977L65.0091 32.9668L60.9476 43.9809L67.8811 45.3998L67.1109 48.8959L59.6701 47.3732L56.4636 56.2051L64.0172 57.7509L63.2919 61.3151L55.1746 59.654L51.0786 70.8378L47.8091 70.1688L51.9615 58.9965L42.7168 57.1046L38.6207 68.2885L35.3513 67.6194ZM43.9494 53.6442L53.1942 55.536L56.4006 46.7042L47.2122 44.8239L43.9494 53.6442Z",
  fill: "#FF5AAD"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M34.7087 66.9754L38.8048 55.7915L32.1531 54.4303L32.8784 50.8661L40.0374 52.3311L43.3002 43.5108L35.9157 41.9996L36.6295 38.4919L44.5777 40.1184L48.6392 29.1043L51.9087 29.7734L47.8472 40.7875L57.0355 42.6678L61.097 31.6537L64.3665 32.3227L60.305 43.3369L67.2385 44.7557L66.4683 48.2519L59.0275 46.7292L55.8211 55.561L63.3747 57.1068L62.6494 60.6711L54.5321 59.01L50.436 70.1938L47.1665 69.5247L51.319 58.3524L42.0742 56.4606L37.9782 67.6444L34.7087 66.9754ZM43.3069 53.0001L52.5516 54.892L55.758 46.0601L46.5697 44.1798L43.3069 53.0001Z",
  fill: "#793F98"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_20895_19964",
  x1: 17.7009,
  y1: 89.394,
  x2: 91.2946,
  y2: 28.6638,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E97903"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0739316,
  stopColor: "#EC8709"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2075,
  stopColor: "#EF9910"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3662,
  stopColor: "#F2A616"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5723,
  stopColor: "#F4AE19"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4B01A"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHashTagShare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hash-tag-share.61dd8e4f7a1cccd0c72759919525330f.svg";